<smart-header [ContextService]="contextService"></smart-header>
<div>
    <router-outlet></router-outlet>
</div>
@defer {
<ui-loader></ui-loader>
<smart-footer [ContextService]="contextService"></smart-footer>

<confirmation-modal></confirmation-modal>
}